import React from 'react';
import PropTypes from 'prop-types';
import BrowserUtils from '../../utils/BrowserUtils';

function CreateBudgetProgress({
  content,
  totalBudgetValue,
  potValue,
  earning,
}) {
  let percentage;
  let potPercentage;
  let potClass;
  let className;
  let icon;
  let potIcon;

  const diff = earning - totalBudgetValue;
  const diff2 = earning - potValue;

  if (diff < 0) {
    percentage = (totalBudgetValue * 100) / earning;
  } else {
    percentage = Math.round((totalBudgetValue * 100) / earning);
  }

  if (diff2 < 0) {
    potPercentage = (potValue * 100) / earning;
  } else {
    potPercentage = Math.round((potValue * 100) / earning);
  }

  if (percentage > 100) {
    className = 'progress-bar progress-bar-danger';
    icon = <span className="icon icon-attention" />;
  } else {
    className = 'progress-bar progress-bar-success pot-green';
  }
  if (percentage >= 100) {
    percentage = 100;
  }

  if (potPercentage > 100) {
    potClass = 'progress-bar progress-bar-danger';
    potIcon = <span className="icon icon-attention" />;
  } else {
    potClass = 'progress-bar progress-bar-success';
  }
  if (potPercentage >= 100) {
    potPercentage = 100;
  }

  let addFadeClass;
  let addFadeClass2;

  if (BrowserUtils.isMobileView()) {
    if (potPercentage > 16) {
      addFadeClass = 'fade in';
    } else {
      addFadeClass = 'fade';
    }
    if (percentage > potPercentage + 22) {
      addFadeClass2 = 'fade in';
    } else {
      addFadeClass2 = 'fade';
    }
  } else {
    if (potPercentage > 10) {
      addFadeClass = 'fade in';
    } else {
      addFadeClass = 'fade';
    }
    if (percentage > potPercentage + 13) {
      addFadeClass2 = 'fade in';
    } else {
      addFadeClass2 = 'fade';
    }
  }

  let shadowClass;
  let shadowClass2;

  if (potPercentage > 87 && potPercentage < 99) {
    shadowClass = 'shadow';
  }
  if (percentage > 87 && percentage < 99) {
    shadowClass2 = 'shadow';
  }

  return (
    <div className="spendings-progressbar">
      <div className="progress">
        <span>{content.spendingProgressText3}</span>
        <div
          className={`${className} ${shadowClass2}`}
          role="progressbar"
          style={{ width: `${percentage}%` }}
        >
          <span className={addFadeClass2}>{content.spendingProgressText1}</span>
          {icon}
        </div>
        <div
          className={`${potClass} ${shadowClass}`}
          role="progressbar"
          style={{ width: `${potPercentage}%` }}
        >
          <span className={addFadeClass}>{content.spendingProgressText2}</span>
          {potIcon}
        </div>
      </div>
    </div>
  );
}

CreateBudgetProgress.propTypes = {
  content: PropTypes.object,
  totalBudgetValue: PropTypes.number,
  potValue: PropTypes.number,
  earning: PropTypes.number,
};

export { CreateBudgetProgress };
